module.exports = __webpack_public_path__ + "img/CompanyLogo2.3fc649b3.jpg";